export const FETCH_TAGS = 'fetchTags';
export const UPDATE_TAGS = 'updateTags';
